<template>
    <b-row>
        <b-col cols="8">
            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}.</div>
            <div style="overflow-y: auto; max-height: 350px;">
                <ul v-for="(asiento, index) in asientos" :key="index" class="resumen d-md-flex">
                    <li class="altcolor-content">
                        <div class="text-bold oswald text-uppercase m-0 w-100">
                            {{ $t('partido.invitacion')}} Nº {{ index + 1 }}
                        </div>
                    </li>
                    <li class="flex-grow-1">
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ asiento.asiento?.zona_nombre }}
                        </div>
                    </li>
                    <li>
                        <div class="h5 text-bold oswald text-uppercase m-0 w-100">
                            {{ $t('general.fila') }}: {{ asiento.asiento?.fila }} - {{ $t('general.butaca') }}: {{ asiento.asiento?.asiento }}   
                        </div>
                    </li>
                    <li class="text-bold">
                        <label class="h5">{{ $t('general.precio') }}</label>
                        <div class="h4 mb-1">
                            {{ 0 | formatear_precio }}
                        </div>
                    </li>
                </ul>
            </div>
            <div v-if="frontend" class="mb-5">
                <label>{{ $t('evento.total_pagar') }}</label>
                <div class="price price-large gradient-color">
                    {{ datos_pago?.amount | formatear_precio }}
                </div>
            </div>
        </b-col>
        <b-col cols="12">
            <FormTerminos 
                :error="error"
                :desactivar="desactivar"
                @continuar="aceptarCondiciones"
            />
        </b-col>
        <b-col v-if="frontend" cols="12" class="pl-0">
            <ResumenPrecioComponent
                :price="0"
                :price_management="datos_pago?.amount || 0"
                :price_management_interno="!price_management_invitaciones ? 1 : 0"
                :iva="manager.iva_partido"
            />
        </b-col>
        <b-col cols="12" class="mt-3 d-flex">
            <template v-if="tienePdf">
                <button
                    class="button large-button effect-button"
                    @click.prevent="descargarPdf"
                >
                    <span>{{ $t('gracias.descargar_pdf') }}</span>
                </button>
                <router-link 
                    tag="a" 
                    :to="{ name: 'back.abonados.index' }"
                    class="button large-button effect-button ml-2"
                >
                    <span>{{ $t("gracias.volver") }}</span>
                </router-link>
            </template>

            <template v-else>
                <button 
                    id="resumen-continuar"
                    :disabled="desactivar || procesando_pago"
                    :class="['button','compra-responsive', { 'effect-button': !(procesando_pago || desactivar) }, !esMovil ? 'large-button effect-button' : '']"
                    @click.prevent="terminar"
                >
                    <span>{{ price_management_invitaciones ? $t('partido.continuar') : $t('perfil_invitaciones.Finalizar_compra') }}</span>
                </button>
                <button 
                    :disabled="procesando_pago || desactivar"
                    :class="['button', 'ml-2', 'compra-responsive', { 'effect-button': !(procesando_pago || desactivar) }, !esMovil ? 'large-button effect-button' : '']"
                    @click.prevent="$emit('volver')"
                >
                    <span>{{ $t('formularios.atras') }}</span>
                </button>
            </template>
        </b-col>
    </b-row>
</template>

<script>
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";

    export default {
        props: {
            session_id: {
                type: String,
                required: true
            },
            asientos: {
                type: Array,
                required: true
            },
            desactivar: {
                type: Boolean,
                default: false
            },
            datos_pago: {
                type: Object
            },
            frontend: {
                type: Boolean,
                default: true
            },
            pedidoInfo: { 
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                error: false,
                localDatos: {},
                esMovil: false,
                terminos: false,
                procesando_pago: false
            }
        },
        methods: {
            onResize() {
                this.esMovil = window.innerWidth < 768;
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.localDatos.privacidad = privacidad;
                this.localDatos.condiciones = condiciones;
                this.localDatos.comunicaciones = comunicaciones;
                this.terminos = continuar == true;
            },
            guardarTerminosCondiciones(){
                const params = {
                    filters: {},
                    privacidad: this.localDatos.privacidad,
                    condiciones: this.localDatos.condiciones,
                    comunicaciones: this.localDatos.comunicaciones,
                    session_id: this.session_id,
                }	
                this.$store.dispatch(this.config.getVuexAlias('front.guardar.terminos.condiciones'), params).catch(error => {
                    this.$toast.error('Error al guardar los terminos y condiciones');
                });
            },
            terminar() {
                this.procesando_pago = true;

                if (this.terminos == true) {
                    this.guardarTerminosCondiciones();
                    if (this.datos_pago?.formulario) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 500);                    
                    } else {
                        this.$emit('terminado', !this.price_management_invitaciones ? true : false, this.localDatos);
                    }
                } else {
                    this.procesando_pago = false;
                    this.error = true;
                }  
            },
            descargarPdf() {
                window.open(this.pedidoInfo.url_pdf, '_blank');
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            price_management_invitaciones() {
                return this.datos_pago?.amount > 0;
            },
            tienePdf() {
                return this.pedidoInfo && this.pedidoInfo.url_pdf && !this.frontend;
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true });
            }
        },
        mounted() {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true });
        },
        components: {
            FormTerminos, ResumenPrecioComponent
        }
    }
</script>
